import * as React from 'react'

/**
 * helper hook for working with hover state in JS,
 * provides the current state and callback that should be hooked
 * on something like `onPointerEnter`/`onPointerLeave` events
 */
export const useHoverState = () => {
  const [isHovered, setIsHovered] = React.useState(false)

  const setHoverStart = React.useCallback(() => setIsHovered(true), [])
  const setHoverEnd = React.useCallback(() => setIsHovered(false), [])

  return { isHovered, setHoverStart, setHoverEnd }
}
